import Http from '@/support/http';

export default {
	sendFormLead(context, payload) {

		return Http.post('v1/lead', payload).then((response) => {
			context.commit('SET_LEAD', response.data);
			return response;
		});

	},
	updateLead(context, payload) {

		return Http.put(`v1/lead/${payload.id}`, payload).then((response) => {
			context.commit('SET_LEAD', response.data);
			return response;
		});

	},
	sendForm(context, payload) {

		return Http.post('v1/school', payload).then((response) => {
			context.commit('SET_LEAD', response.data);
			return response;
		});

	}
};



// WEBPACK FOOTER //
// ./sources/app/simulator/simulator/actions.js